import { DatadogProvider } from '@datadog/openfeature-browser';
import type { Provider } from '@openfeature/web-sdk';
import { createGiveWayFetch } from '@ringba/core/utils';
import { logger } from './logger';
import type { CreateSystemFlagsClientOptions } from './types';

/** The provider needs this long after its request gives way to read its snapshot, before the client's settle timeout fires. */
const SNAPSHOT_READ_MARGIN_MS = 500;

export interface DatadogProviderOptions {
  /** The client's settle timeout, which the provider's request gives way before. */
  timeoutMs: number;
  /** Called when a request that gave way answers OK. */
  onLateAnswer: () => void;
}

/** `undefined` when `config` is absent or missing `clientToken`/`applicationId` — the caller falls back to no provider. */
export function createDatadogProvider(
  config: CreateSystemFlagsClientOptions['datadog'],
  { timeoutMs, onLateAnswer }: DatadogProviderOptions,
): Provider | undefined {
  if (!config?.clientToken || !config.applicationId) {
    return undefined;
  }

  return new DatadogProvider({
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    site: config.site,
    env: config.flagsEnv ?? config.env,
    version: config.version,
    enableExposureLogging: true,
    enableFlagEvaluationTracking: true,
    flagConfigurationFetch: createGiveWayFetch({
      giveWayMs: timeoutMs - SNAPSHOT_READ_MARGIN_MS,
      onLateAnswer,
      logger,
    }),
  });
}
